module.exports = __webpack_public_path__ + "static/img/CH@3x.77086266.jpg";